var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    timerBackgroundColor: colors.contrasts.grey1111,
    timerColor: colors.contrasts.grey4570,
    timerBorderWidth: borders.widthSmall,
    timerBorderColor: colors.contrasts.grey1214,
    timerBorderRadius: borders.radiusMedium,
    timerFontSize: typography.fontSizeMedium,
    timerPadding: spacing.xxSmall,
    timerMargin: spacing.small,
    timerRightPadding: spacing.xxSmall,
    timeRemainingLabelFontSize: typography.fontSizeXSmall
  };
};
export default generateComponentTheme;